import classnames from 'classnames'
import React from 'react'

import {
  getProductLinkWithSelectedColor,
  getQuincePriceForProduct,
  hasDifferentPrices,
} from '@src/components/product-card/product-card.helpers'
import { IWebsiteProduct } from '@src/components/product-card/product-card.types'

import { makePriceDisplayValue } from '../../molecules/productCard/productCard.helpers'
import { Image, ImageProps } from '../image'
import Link from '../link'

import styles from './productWithTextCard.module.scss'

export interface ProductWithTextCardProps {
  imageProps: ImageProps
  product: IWebsiteProduct
  className?: string
  overrideProductLink?: string
}

const ProductWithTextCard = ({
  imageProps,
  product,
  className = '',
  overrideProductLink,
}: ProductWithTextCardProps) => {
  const classes = classnames(styles.container, className)

  const price = makePriceDisplayValue(getQuincePriceForProduct(product.cardVariants))
  const showFrom = hasDifferentPrices(product.cardVariants)
  const hrefLink = overrideProductLink ? `/${overrideProductLink}` : getProductLinkWithSelectedColor(product.slug)

  return (
    <div className={classes}>
      <Link href={hrefLink}>
        <div>
          <Image className={styles.image} {...imageProps} alt={imageProps.alt} />
          <div className={classnames(['body1_grosa', styles.title])}>{product.title}</div>
          <div className="body2_grosa">{`${showFrom ? 'From ' : ''}${price}`}</div>
        </div>
      </Link>
    </div>
  )
}

export default ProductWithTextCard
